export const USER = require("../assets/user.png");
export const VIDEO = require("../assets/Mask group.png");
export const AUDIO = require("../assets/audio.mp3");
export const LOGO = require("../assets/logo.png");
export const LOGO1 = require("../assets/logo1.png");
export const THUMBNAIL = require("../assets/thumbnail.jpg");
export const MAlE = require("../assets/male.png");
export const USER1 = require("../assets/user.jpg");
export const JACK = require("../assets/Ellipse.png");
export const LISA = require("../assets/Ellipse 1 (1).png");
export const VIEW = require("../assets/passIconGreen.png");
export const RECORDINGWAVES = require("../assets/recordingWaves.gif");

